<div class="container-fluid glb-popup">
  @if (formLoading) {
    <div class="kbm-search-loading">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
  @if (!ownerLeadProfileId) {
    <h2 class="kbm-section-headline"> {{formTitle}}</h2>
  }
  @if (ownerLeadProfileId) {
    <h2 class="kbm-section-headline">Edit {{ownerLeadProfile?.firstName}} {{ownerLeadProfile?.lastName}}</h2>
  }

  <!-- KBM 2026: Lead Stage Stepper -->
  @if (ownerLeadProfileId && ownerLeadProfile?.leadStatus) {
    <div class="kbm-stage-stepper">
      @for (stage of [{label:'Prospect',v:1},{label:'Lead',v:2},{label:'Opportunity',v:3},{label:'Win',v:4}]; track stage.v) {
        <div class="kbm-stage"
             [class.kbm-stage-current]="ownerLeadProfile.leadStatus === stage.v"
             [class.kbm-stage-done]="ownerLeadProfile.leadStatus > stage.v && ownerLeadProfile.leadStatus !== 5"
             [class.kbm-stage-loss]="stage.v === 4 && ownerLeadProfile.leadStatus === 5">
          <div class="kbm-stage-dot">{{ stage.v }}</div>
          <div class="kbm-stage-label">{{ ownerLeadProfile.leadStatus === 5 && stage.v === 4 ? 'Loss' : stage.label }}</div>
        </div>
      }
    </div>

    <!-- KBM 2026: Quick Actions + Linked Proformas -->
    <div class="kbm-quick-actions">
      <div class="kbm-quick-actions-meta">
        <span class="kbm-meta-label">Linked Proformas</span>
        <span class="kbm-meta-value">{{ ownerLeadProfile?.propertyLeadProfiles?.length || 0 }} property
          {{ (ownerLeadProfile?.propertyLeadProfiles?.length || 0) === 1 ? 'lead' : 'leads' }}</span>
      </div>
      <div class="kbm-quick-actions-buttons">
        <a routerLink="/proforma-list" class="kbm-btn kbm-btn-primary">
          <i class="pi pi-file"></i> Generate Proforma
        </a>
        <button type="button" class="kbm-btn kbm-btn-outline"
                *ngIf="ownerLeadProfile?.emailAddress"
                (click)="null">
          <i class="pi pi-envelope"></i> Send Email
        </button>
        <button type="button" class="kbm-btn kbm-btn-outline" (click)="formAddPropertyLead()">
          <i class="pi pi-plus"></i> Link Property
        </button>
      </div>
    </div>
  }
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button (click)="closePopUpOfQuote()" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <mat-tab-group class="tabs-group edit-order-grp">
      <mat-tab label="Owner Lead Profile">
        <div [formGroup]="form1" class="forms w-100 d-block owner-lead-profile position-relative">
          <div class="px-2">

            @if (formAlert) {
              <div class="w-100 mb-3">
                <div class="w-100"
                  style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                  <p><b>{{formAlert}}</b></p>
                </div>
              </div>
            }
            @if (isDisplayPropertyProfile) {
              <div>
                <div>
                  <div class="row">
                    <div class="col-lg-7">
                      @if (leadProfileAge) {
                        <div>
                          <span class="fw-bold">Age:</span> <span class="fw-normal">{{ leadProfileAge }}</span>
                        </div>
                      }
                      <div>
                        <div class="fw-bold my-2 title">Status</div>
                        <div class="row">
                          <div class="col-lg-3 col-sm-12">
                            <span class="p-float-label required-field w-100 mb-3">
                              <p-dropdown [options]="leadStatuses" formControlName="leadStatus" optionLabel="name" optionValue="value"
                                [filter]="true" filterBy="value" [showClear]="false" placeholder="Select Status"
                              [dropdownIcon]="'fa fa-caret-down'" [panelStyle]="{ 'max-height': 'none' }"></p-dropdown>
                              <label for="Select Status">Select Status</label>
                              @for (validation of validationMessages.leadStatus; track validation) {
                                <span>
                                  @if (form1.get('leadStatus').hasError(validation.type) && (form1.get('leadStatus').dirty || form1.get('leadStatus').touched)) {
                                    <small class="p-invalid"
                                      >
                                      {{validation.message}}
                                    </small>
                                  }
                                </span>
                              }
                            </span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-3 col-sm-12">
                            <span class="p-float-label required-field w-100 mb-3">
                              <p-dropdown [options]="ownershipInterests" formControlName="ownershipInterest" optionLabel="name"
                                optionValue="value" [filter]="true" filterBy="value" [showClear]="false"
                                placeholder="Ownership Interest" [dropdownIcon]="'fa fa-caret-down'"
                              [panelStyle]="{ 'max-height': 'none' }"></p-dropdown>
                              <label for="Select Status">Ownership Interest</label>
                              @for (validation of validationMessages.ownershipInterest; track validation) {
                                <span>
                                  @if (form1.get('ownershipInterest').hasError(validation.type) && (form1.get('ownershipInterest').dirty || form1.get('ownershipInterest').touched)) {
                                    <small class="p-invalid"
                                      >
                                      {{validation.message}}
                                    </small>
                                  }
                                </span>
                              }
                            </span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-3 col-sm-12">
                            <span class="p-float-label required-field w-100 mb-3">
                              <p-dropdown [options]="probabilitiesList" formControlName="probability" optionLabel="name"
                                optionValue="value" [filter]="true" filterBy="value" [showClear]="false" placeholder="Probability"
                              [dropdownIcon]="'fa fa-caret-down'"></p-dropdown>
                              <label for="Probability">Probability</label>
                              @for (validation of validationMessages.probability; track validation) {
                                <span>
                                  @if (form1.get('probability').hasError(validation.type) && (form1.get('probability').dirty || form1.get('probability').touched)) {
                                    <small class="p-invalid"
                                      >
                                      {{validation.message}}
                                    </small>
                                  }
                                </span>
                              }
                            </span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-8 pe-0">
                            <span class="p-float-label required-field w-100 mb-3">
                              <p-autoComplete [suggestions]="taskUserSuggestions" [multiple]="false"
                                [forceSelection]="false" [dropdown]="false" [style]="{'width':'100%','padding-bottom':'20px'}"
                                [inputStyle]="{'width':'100%'}" [forceSelection]="true" [minLength]="1" unique="true"
                                field="summary" (completeMethod)="findUsersWith($event)" formControlName="assignToSalesAgnt1">
                              </p-autoComplete>
                              <label for="assignToSalesAgnt1">Sales Agent1 (Enter name to get agent1
                              options)</label>
                              @if (isAgent1) {
                                <small>Agent1 not found (Please create new user, If you are not
                                  able to found
                                agent)</small>
                              }
                            </span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-8 pe-0">
                            <span class="p-float-label required-field w-100 mb-3">
                              <p-autoComplete [suggestions]="taskUserSuggestions" [multiple]="false"
                                [forceSelection]="false" [dropdown]="false" [style]="{'width':'100%','padding-bottom':'20px'}"
                                [inputStyle]="{'width':'100%'}" [forceSelection]="true" [minLength]="1" unique="true" field="summary"
                                (completeMethod)="findUsersWith2($event)" formControlName="assignToSalesAgnt2">
                              </p-autoComplete>
                              <label for="assignToSalesAgnt2">Sales Agent2 (Enter name to get agent2
                              options)</label>
                              @if (isAgent2) {
                                <small>Agent2 not found (Please create new user, If you are not
                                  able to found
                                agent)</small>
                              }
                            </span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-8 pe-0">
                            <span class="p-float-label required-field w-100 mb-3">
                              <p-autoComplete [suggestions]="taskUserSuggestions" [multiple]="false"
                                [forceSelection]="false" [dropdown]="false" [style]="{'width':'100%','padding-bottom':'20px'}"
                                [inputStyle]="{'width':'100%'}" [forceSelection]="true" [minLength]="1" unique="true" field="summary"
                                (completeMethod)="findUsersWith3($event)" formControlName="assignToSalesAgnt3">
                              </p-autoComplete>
                              <label for="assignToSalesAgnt3">Sales Agent3 (Enter name to get agent3
                              options)</label>
                              @if (isAgent3) {
                                <small>Agent3 not found (Please create new user, If you are not
                                  able to found
                                agent)</small>
                              }
                            </span>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div class="fw-bold my-2 title">Owner</div>
                        <div class="row">
                          <div class="col-lg-2 col-sm-12">
                            <span class="p-float-label required-field w-100 mb-3">
                              <input formControlName="firstName" id="firstName" type="text" pInputText>
                              <label for="firstName">First Name</label>
                              @for (validation of validationMessages.firstName; track validation) {
                                <span>
                                  @if (form1.get('firstName').hasError(validation.type) && (form1.get('firstName').dirty || form1.get('firstName').touched)) {
                                    <small class="p-invalid"
                                      >{{validation.message}}
                                    </small>
                                  }
                                </span>
                              }
                            </span>
                          </div>
                          <div class="col-lg-2 col-sm-12">
                            <span class="p-float-label required-field w-100 mb-3">
                              <input formControlName="lastName" id="lastName" type="text" pInputText>
                              <label for="lastName">Last Name</label>
                              @for (validation of validationMessages.lastName; track validation) {
                                <span>
                                  @if (form1.get('lastName').hasError(validation.type) && (form1.get('lastName').dirty || form1.get('lastName').touched)) {
                                    <small class="p-invalid"
                                      >{{validation.message}}
                                    </small>
                                  }
                                </span>
                              }
                            </span>
                          </div>
                          <div class="col-lg-4">
                            <span class="p-float-label required-field w-100 mb-3">
                              <input formControlName="fullName" id="fullName" type="text" pInputText>
                              <label for="fullName">Full Name</label>
                              @for (validation of validationMessages.fullName; track validation) {
                                <span>
                                  @if (form1.get('fullName').hasError(validation.type) && (form1.get('fullName').dirty || form1.get('fullName').touched)) {
                                    <small class="p-invalid"
                                      >{{validation.message}}
                                    </small>
                                  }
                                </span>
                              }
                            </span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-4">
                            <span class="p-float-label required-field w-100 mb-3">
                              <input formControlName="emailAddress" id="emailAddress" type="email" pInputText>
                              <label for="emailAddress">Email Address</label>
                              @for (validation of validationMessages.emailAddress; track validation) {
                                <span>
                                  @if (form1.get('emailAddress').hasError(validation.type) && (form1.get('emailAddress').dirty || form1.get('emailAddress').touched)) {
                                    <small class="p-invalid"
                                      >{{validation.message}}
                                    </small>
                                  }
                                </span>
                              }
                            </span>
                          </div>
                          <div class="col-lg-4">
                            <span class="p-float-label required-field w-100 mb-3">
                              <input formControlName="emailAddress2" id="emailAddress2" type="email" pInputText>
                              <label for="emailAddress2">Email Address 2</label>
                              @for (validation of validationMessages.emailAddress2; track validation) {
                                <span>
                                  @if (form1.get('emailAddress2').hasError(validation.type) && (form1.get('emailAddress2').dirty || form1.get('emailAddress2').touched)) {
                                    <small class="p-invalid"
                                      >{{validation.message}}
                                    </small>
                                  }
                                </span>
                              }
                            </span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-2 col-sm-12">
                            <span class="p-float-label required-field w-100 mb-3">
                              <input formControlName="mobilePhone" id="mobilePhone" type="text" pInputText>
                              <label for="mobilePhone">Mobile Phone</label>
                              @for (validation of validationMessages.mobilePhone; track validation) {
                                <span>
                                  @if (form1.get('mobilePhone').hasError(validation.type) && (form1.get('mobilePhone').dirty || form1.get('mobilePhone').touched)) {
                                    <small class="p-invalid"
                                      >{{validation.message}}
                                    </small>
                                  }
                                </span>
                              }
                            </span>
                          </div>
                          <div class="col-lg-2 col-sm-12">
                            <span class="p-float-label required-field w-100 mb-3">
                              <input formControlName="phone2" id="phone2" type="text" pInputText>
                              <label for="phone2">Other Phone</label>
                              @for (validation of validationMessages.phone2; track validation) {
                                <span>
                                  @if (form1.get('phone2').hasError(validation.type) && (form1.get('phone2').dirty || form1.get('phone2').touched)) {
                                    <small class="p-invalid"
                                      >{{validation.message}}
                                    </small>
                                  }
                                </span>
                              }
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    @if (ownerLeadProfileId) {
                      <div class="col-lg-5 plp-content">
                        <app-notes-chat [config]="notesChatConfig" [noteSourceId]="ownerLeadProfileId" [noteSource]="10"
                          (noteAdded)="touchOwnerLeadProfile()"
                          (noteUpdated)="touchOwnerLeadProfile()"
                          (noteDeleted)="touchOwnerLeadProfile()">
                        </app-notes-chat>
                      </div>
                    }
                  </div>
                  <div>
                    <div class="fw-bold my-2 title">Properties</div>
                    <div>
                      <div class="row">
                        <div class="col-lg-6">
                          <span class="p-float-label fullwidthinput required-field mb-3 pe-0">
                            <p-autoComplete #locationSearch class="error-bg"
                              placeholder="" formControlName="propertyLeadProfilesObj"
                              [suggestions]="filteredNames"
                              (completeMethod)="changeNameFilter($event.query)"
                              (onSelect)="onPropertyLeadSelect($event)" field="." [minLength]="1"
                              forceSelection=true>
                              <ng-template let-filteredNames pTemplate="item">
                                <div class="country-item">
                                  <div>
                                    {{filteredNames.subjAdrStreet}}
                                    {{filteredNames.subjAdrDevelopmentName}}
                                    {{filteredNames.firstName}} {{filteredNames.lastName}}
                                  {{filteredNames.propertyLeadProfileId}} </div>
                                </div>
                              </ng-template>
                            </p-autoComplete>
                            <label
                              for="Search Property Lead Profiles By DevelopmentName, Street, firstName, lastName">Search
                              Property Lead Profiles By Development Name, Street, Firstname,
                            Lastname</label>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div>
                      @if (ownerLeadProfile?.ownerLeadProfileId && ownerLeadProfile?.propertyLeadProfiles?.length > 0) {
                        <h5
                          >
                        Property Lead Profiles</h5>
                      }
                      @if (ownerLeadProfile?.ownerLeadProfileId && ownerLeadProfile?.propertyLeadProfiles?.length > 0) {
                        <hr
                          >
                      }
                      @if (ownerLeadProfile?.ownerLeadProfileId && ownerLeadProfile?.propertyLeadProfiles?.length > 0) {
                        <div
                          class="col-lg-12">
                          <span class="p-float-label required-field w-100 mb-3">
                            <p-table [value]="ownerLeadProfile?.propertyLeadProfiles"
                              [tableStyle]="{ 'min-width': 'auto' }">
                              <ng-template pTemplate="header">
                                <tr>
                                  <th [ngStyle]="{'width': 'auto'}">PropLeadProfId</th>
                                  <th [ngStyle]="{'width': 'auto'}">First Name</th>
                                  <th [ngStyle]="{'width': 'auto'}">Last Name</th>
                                  <th [ngStyle]="{'width': 'auto'}">DevelopmentName</th>
                                  <th [ngStyle]="{'width': 'auto'}">Street</th>
                                  <th></th>
                                </tr>
                              </ng-template>
                              <ng-template pTemplate="body" let-propertyLeadProfile>
                                <tr>
                                  <td>
                                    {{ propertyLeadProfile?.propertyLeadProfileId }}
                                  </td>
                                  <td>
                                    {{ propertyLeadProfile?.firstName }}
                                  </td>
                                  <td>
                                    {{ propertyLeadProfile?.lastName }}
                                  </td>
                                  <td>
                                    {{ propertyLeadProfile?.subjAdrDevelopmentName }}
                                  </td>
                                  <td>
                                    {{ propertyLeadProfile?.subjAdrStreet }}
                                  </td>
                                  <td>
                                    <span style="float:none">
                                      <a>
                                        <i class="pi pi-trash" aria-hidden="true"
                                          style="color:red; font-size:110%; padding-right:5px;"
                                        (click)="onFormDeletePropertyLeadProfile(propertyLeadProfile)"></i>
                                      </a>
                                    </span>
                                  </td>
                                </tr>
                              </ng-template>
                            </p-table>
                          </span>
                        </div>
                      }
                    </div>
                  </div>
                  <div>
                    <div class="fw-bold my-2 title">Mailing Address</div>
                    <div class="row">
                      <div class="col-lg-3">
                        <span class="p-float-label w-100 mb-3">
                          <input formControlName="mailAdrStreet" id="mailAdrStreet" type="text"
                            pInputText>
                          <label for="mailAdrStreet">Mail Address Street</label>
                          @for (validation of validationMessages.mailAdrStreet; track validation) {
                            <span>
                              @if (form1.get('mailAdrStreet').hasError(validation.type) && (form1.get('mailAdrStreet').dirty || form1.get('mailAdrStreet').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                      <div class="col-lg-3">
                        <span class="p-float-label w-100 mb-3">
                          <input formControlName="mailAdrStreet2" id="mailAdrStreet2" type="text"
                            pInputText>
                          <label for="mailAdrStreet2">Mail Address Street2</label>
                          @for (validation of validationMessages.mailAdrStreet2; track validation) {
                            <span>
                              @if (form1.get('mailAdrStreet2').hasError(validation.type) && (form1.get('mailAdrStreet2').dirty || form1.get('mailAdrStreet2').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-2">
                        <span class="p-float-label w-100 mb-3">
                          <input formControlName="mailAdrCity" id="mailAdrCity" type="text"
                            pInputText>
                          <label for="mailAdrCity">Mail Address City</label>
                          @for (validation of validationMessages.mailAdrCity; track validation) {
                            <span>
                              @if (form1.get('mailAdrCity').hasError(validation.type) && (form1.get('mailAdrCity').dirty || form1.get('mailAdrCity').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                      <div class="col-lg-2">
                        <span class="p-float-label w-100 mb-3">
                          <p-dropdown [options]="states" formControlName="mailAdrState"
                            optionLabel="name" optionValue="abbr" [filter]="true"
                            filterBy="name" [showClear]="false" placeholder="State"
                            [dropdownIcon]="'fa fa-caret-down'">
                          </p-dropdown>
                          <label for="State">State</label>
                          @for (validation of validationMessages.mailAdrState; track validation) {
                            <span>
                              @if (form1.get('mailAdrState').hasError(validation.type) && (form1.get('mailAdrState').dirty || form1.get('mailAdrState').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                      <div class="col-lg-2">
                        <span class="p-float-label w-100 mb-3">
                          <input formControlName="mailAdrPostalCode" id="mailAdrPostalCode"
                            type="text" pInputText>
                          <label for="mailAdrPostalCode">Postal Code</label>
                          @for (validation of validationMessages.mailAdrPostalCode; track validation) {
                            <span>
                              @if (form1.get('mailAdrPostalCode').hasError(validation.type) && (form1.get('mailAdrPostalCode').dirty || form1.get('mailAdrPostalCode').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-6">
                        <span class="p-float-label required-field w-100">
                          <textarea formControlName="mailAdrLocationDesc" id="mailAdrLocationDesc"
                          [rows]="2" pInputTextarea></textarea>
                          <label for="mailAdrLocationDesc">Mailing Address Location
                          Description</label>
                          @for (validation of validationMessages.mailAdrLocationDesc; track validation) {
                            <span>
                              @if (form1.get('mailAdrLocationDesc').hasError(validation.type) && (form1.get('mailAdrLocationDesc').dirty || form1.get('mailAdrLocationDesc').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="fw-bold my-2 title">Outcome</div>
                    <div class="row">
                      <div class="col-lg-3">
                        <span class="p-float-label required-field w-100 mb-3">
                          <p-dropdown [options]="winReasons" formControlName="winReason"
                            optionLabel="name" optionValue="value" [filter]="true" filterBy="value"
                            [showClear]="false" placeholder="Win Reason"
                          [dropdownIcon]="'fa fa-caret-down'"></p-dropdown>
                          <label for="Win Reason">Win Reason</label>
                          @for (validation of validationMessages.winReason; track validation) {
                            <span>
                              @if (form1.get('winReason').hasError(validation.type) && (form1.get('winReason').dirty || form1.get('winReason').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-3">
                        <span class="p-float-label required-field w-100 mb-3">
                          <p-dropdown [options]="lossReasons" formControlName="lossReason"
                            optionLabel="name" optionValue="value" [filter]="true" filterBy="value"
                            [showClear]="false" placeholder="Loss Reason"
                          [dropdownIcon]="'fa fa-caret-down'"></p-dropdown>
                          <label for="Loss Reason">Loss Reason</label>
                          @for (validation of validationMessages.lossReason; track validation) {
                            <span>
                              @if (form1.get('lossReason').hasError(validation.type) && (form1.get('lossReason').dirty || form1.get('lossReason').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="fw-bold my-2 title">Inquiry</div>
                    <div class="row">
                      <div class="col-lg-6">
                        <span class="p-float-label w-100 mb-3">
                          <input formControlName="subjAdrDevelopmentName" id="subjAdrDevelopmentName"
                            type="text" pInputText>
                          <label for="subjAdrDevelopmentName">Subj Address Development Name</label>
                          @for (validation of validationMessages.subjAdrDevelopmentName; track validation) {
                            <span>
                              @if (form1.get('subjAdrDevelopmentName').hasError(validation.type) && (form1.get('subjAdrDevelopmentName').dirty || form1.get('subjAdrDevelopmentName').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-3">
                        <span class="p-float-label w-100 mb-3">
                          <input formControlName="subjAdrStreet" id="subjAdrStreet" type="text"
                            pInputText>
                          <label for="subjAdrStreet">Subject Address Street</label>
                          @for (validation of validationMessages.subjAdrStreet; track validation) {
                            <span>
                              @if (form1.get('subjAdrStreet').hasError(validation.type) && (form1.get('subjAdrStreet').dirty || form1.get('subjAdrStreet').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                      <div class="col-lg-3">
                        <span class="p-float-label w-100 mb-3">
                          <input formControlName="subjAdrStreet2" id="subjAdrStreet2" type="text"
                            pInputText>
                          <label for="subjAdrStreet2">Subject Address Street2</label>
                          @for (validation of validationMessages.subjAdrStreet2; track validation) {
                            <span>
                              @if (form1.get('subjAdrStreet2').hasError(validation.type) && (form1.get('subjAdrStreet2').dirty || form1.get('subjAdrStreet2').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-2">
                        <span class="p-float-label w-100 mb-3">
                          <input formControlName="subjAdrCity" id="subjAdrCity" type="text"
                            pInputText>
                          <label for="subjAdrCity">Subject Address City</label>
                          @for (validation of validationMessages.subjAdrCity; track validation) {
                            <span>
                              @if (form1.get('subjAdrCity').hasError(validation.type) && (form1.get('subjAdrCity').dirty || form1.get('subjAdrCity').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                      <div class="col-lg-2">
                        <span class="p-float-label w-100 mb-3">
                          <p-dropdown [options]="states" formControlName="subjAdrState"
                            optionLabel="name" optionValue="abbr" [filter]="true"
                            filterBy="name" [showClear]="false" placeholder="State"
                            [dropdownIcon]="'fa fa-caret-down'">
                          </p-dropdown>
                          <label for="State">State</label>
                          @for (validation of validationMessages.subjAdrState; track validation) {
                            <span>
                              @if (form1.get('subjAdrState').hasError(validation.type) && (form1.get('subjAdrState').dirty || form1.get('subjAdrState').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                      <div class="col-lg-2">
                        <span class="p-float-label w-100 mb-3">
                          <input formControlName="subjAdrPostalCode" id="subjAdrPostalCode"
                            type="text" pInputText>
                          <label for="subjAdrPostalCode">Postal Code</label>
                          @for (validation of validationMessages.subjAdrPostalCode; track validation) {
                            <span>
                              @if (form1.get('subjAdrPostalCode').hasError(validation.type) && (form1.get('subjAdrPostalCode').dirty || form1.get('subjAdrPostalCode').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-6">
                        <span class="p-float-label required-field w-100 mb-3">
                          <textarea formControlName="subjAdrLocationDesc" id="subjAdrLocationDesc"
                          [rows]="2" pInputTextarea></textarea>
                          <label for="subjAdrLocationDesc">Address Location Desc</label>
                          @for (validation of validationMessages.subjAdrLocationDesc; track validation) {
                            <span>
                              @if (form1.get('subjAdrLocationDesc').hasError(validation.type) && (form1.get('subjAdrLocationDesc').dirty || form1.get('subjAdrLocationDesc').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-6">
                        <span class="p-float-label required-field w-100">
                          <textarea formControlName="customerNotes" id="customerNotes" [rows]="2"
                          pInputTextarea></textarea>
                          <label for="customerNotes">Customer Notes</label>
                          @for (validation of validationMessages.customerNotes; track validation) {
                            <span>
                              @if (form1.get('customerNotes').hasError(validation.type) && (form1.get('customerNotes').dirty || form1.get('customerNotes').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="mt-3">
                    <div class="fw-bold my-2 title">Management Status</div>
                    <div class="row">
                      <div class="col-lg-2">
                        <span class="p-float-label required-field w-100 mb-3">
                          <p-dropdown [options]="ownershipInterests" formControlName="ownershipStatus"
                            optionLabel="name" optionValue="value" [filter]="true" filterBy="value"
                            [showClear]="false" placeholder="Select Status"
                          [dropdownIcon]="'fa fa-caret-down'"></p-dropdown>
                          <label for="Select ownershipStatus">Comp. Status</label>
                          @for (validation of validationMessages.ownershipStatus; track validation) {
                            <span>
                              @if (form1.get('ownershipStatus').hasError(validation.type) && (form1.get('ownershipStatus').dirty || form1.get('ownershipStatus').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                      <div class="col-lg-2">
                        <span class="p-float-label required-field w-100 mb-3">
                          <p-dropdown [options]="ownershipCompanies" formControlName="compName"
                            optionLabel="name" optionValue="id" [filter]="true" filterBy="value"
                            [showClear]="false" placeholder="Competitor Name"
                          [dropdownIcon]="'fa fa-caret-down'"></p-dropdown>
                          <label for="Competitor Name">Comp. Name</label>
                          @for (validation of validationMessages.compName; track validation) {
                            <span>
                              @if (form1.get('compName').hasError(validation.type) && (form1.get('compName').dirty || form1.get('compName').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                      <div class="col-lg-2">
                        <span class="p-float-label required-field w-100 mb-3">
                          <p-dropdown [options]="compNegReasons" formControlName="compNegReason"
                            optionLabel="name" optionValue="value" [filter]="true" filterBy="value"
                            [showClear]="false" placeholder="Competitor Negative Reason"
                          [dropdownIcon]="'fa fa-caret-down'"></p-dropdown>
                          <label for="Competitor Name">Comp. Negative Reason</label>
                          @for (validation of validationMessages.compNegReason; track validation) {
                            <span>
                              @if (form1.get('compNegReason').hasError(validation.type) && (form1.get('compNegReason').dirty || form1.get('compNegReason').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-3">
                        <span class="p-float-label required-field w-100">
                          <textarea formControlName="compNegDesc" id="compNegDesc" [rows]="2"
                          pInputTextarea></textarea>
                          <label for="compNegDesc">Comp. Negative Description</label>
                          @for (validation of validationMessages.compNegDesc; track validation) {
                            <span>
                              @if (form1.get('compNegDesc').hasError(validation.type) && (form1.get('compNegDesc').dirty || form1.get('compNegDesc').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                      <div class="col-lg-3">
                        <span class="p-float-label required-field w-100">
                          <textarea formControlName="compPosDesc" id="compPosDesc" [rows]="2"
                          pInputTextarea></textarea>
                          <label for="compPosDesc">Comp. Positive Description</label>
                          @for (validation of validationMessages.compPosDesc; track validation) {
                            <span>
                              @if (form1.get('compPosDesc').hasError(validation.type) && (form1.get('compPosDesc').dirty || form1.get('compPosDesc').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-lg-2">
                        <span class="p-float-label required-field w-100 mb-3">
                          <p-calendar formControlName="compContractExpDate"
                          inputId="compContractExpDate"></p-calendar>
                          <label for="compContractExpDate">Comp. Contract Exp.</label>
                          @for (validation of validationMessages.compContractExpDate; track validation) {
                            <span>
                              @if (form1.get('compContractExpDate').hasError(validation.type) && (form1.get('compContractExpDate').dirty || form1.get('compContractExpDate').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                      <div class="col-lg-2">
                        <span class="p-float-label required-field w-100 mb-3">
                          <p-inputNumber [style]="{'width':'100%'}" formControlName="compMgmtFee"
                            [minFractionDigits]="2" inputId="currency-us" mode="currency"
                            currency="USD" locale="en-US">
                          </p-inputNumber>
                          <label for="compMgmtFee">Comp. Mgmt Fee $</label>
                          @for (validation of validationMessages.compMgmtFee; track validation) {
                            <span>
                              @if (form1.get('compMgmtFee').hasError(validation.type) && (form1.get('compMgmtFee').dirty || form1.get('compMgmtFee').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                      <div class="col-lg-2">
                        <span class="p-float-label required-field w-100 mb-3">
                          <p-inputNumber [style]="{'width':'100%'}" formControlName="currentGrossRev"
                            [minFractionDigits]="2" inputId="currency-us" mode="currency"
                            currency="USD" locale="en-US">
                          </p-inputNumber>
                          <label for="currentGrossRev">Curr. Gross Rev. $</label>
                          @for (validation of validationMessages.currentGrossRev; track validation) {
                            <span>
                              @if (form1.get('currentGrossRev').hasError(validation.type) && (form1.get('currentGrossRev').dirty || form1.get('currentGrossRev').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                @if (ownerLeadProfileId) {
                  <hr>
                  }
                  @if (ownerLeadProfileId) {
                    <div>
                      <app-tag-join-select [tagSource]="10" [tagSourceId]="ownerLeadProfileId" tagType="4"
                        (messageEvent)="setAssignedToTagId($event)">
                      </app-tag-join-select>
                    </div>
                  }
                  @if (ownerLeadProfileId) {
                    <hr>
                    }
                    @if (ownerLeadProfileId) {
                      <div>
                        <app-proforma-list [ownerLeadProfileId]="ownerLeadProfileId"></app-proforma-list>
                      </div>
                    }
                    @if (ownerLeadProfileId) {
                      <hr>
                      }
                    </div>
                  }
                </div>


                <hr>
                  <div class="row m-0">
                    <div class="col-lg-12">
                      <div class="btn-group btn-group-mobile d-flex flex-wrap">
                        <div class="button-group">
                          @if (ownerLeadProfileId) {
                            <button pButton
                              class="btn-delete p-button-outlined p-button-danger" (click)="onFormDelete()">Delete
                            Owner Lead Profile</button>
                          }
                        </div>

                        <div class="button-group">
                          <button pButton class="btn-cancel p-button-text"
                          (click)="closePopUpOfQuote()">Cancel</button>
                          @if (!ownerLeadProfileId) {
                            <button pButton class="btn-addt p-button"
                              (click)="formAdd()">Add
                            Owner Lead Profile</button>
                          }

                          @if (ownerLeadProfileId) {
                            <button pButton class="btn-upt p-button"
                              (click)="formUpdate()">Update
                            Owner Lead Profile</button>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-tab>
              <mat-tab label="Email & Text">
                <app-inbox-list-vertical [msgTopic]="2300" [msgTopicId]="ownerLeadProfileId"
                [ownerEmail]="ownerLeadProfile?.emailAddress" [msgContext]="9"></app-inbox-list-vertical>
              </mat-tab>
              <mat-tab label="History">
                @if (ownerLeadProfileId) {
                  <app-audit-list
                  [auditUrl]="'owner-lead-profiles/' + ownerLeadProfileId + '/audit'"></app-audit-list>
                }
              </mat-tab>

              @if (errorList.length > 0 && showValidationError) {
                <p-dialog header="Errors" [(visible)]="showValidationErrors"
                  [style]="{width: 'auto', height: 'auto'}">
                  <div class="error-mess" [innerHTML]="errorMessages"></div>
                </p-dialog>
              }
            </mat-tab-group>
          </div>